// TODO: remover lista de domínios permitidos depois da FASE-2 de testes
export const ALLOWED_DOMAINS = ["@zig.fun", "@zigpay.com.br"];
